module.exports = __webpack_public_path__ + "static/media/pic.3ae49a37.jpg";